(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-customer-sector', {
            parent: 'entity',
            url: '/event-customer-sector?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventCustomerSector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-customer-sector/event-customer-sectors.html',
                    controller: 'EventCustomerSectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventCustomerSector');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-customer-sector-detail', {
            parent: 'entity',
            url: '/event-customer-sector/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventCustomerSector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-customer-sector/event-customer-sector-detail.html',
                    controller: 'EventCustomerSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventCustomerSector');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventCustomerSector', function($stateParams, EventCustomerSector) {
                    return EventCustomerSector.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-customer-sector.new', {
            parent: 'event-customer-sector',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-customer-sector/event-customer-sector-dialog.html',
                    controller: 'EventCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                latitude: null,
                                longitude: null,
                                agreedPercent: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('event-customer-sector');
                });
            }]
        })
        .state('event-customer-sector.edit', {
            parent: 'event-customer-sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-customer-sector/event-customer-sector-dialog.html',
                    controller: 'EventCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventCustomerSector', function(EventCustomerSector) {
                            return EventCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-customer-sector.delete', {
            parent: 'event-customer-sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-customer-sector/event-customer-sector-delete-dialog.html',
                    controller: 'EventCustomerSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventCustomerSector', function(EventCustomerSector) {
                            return EventCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
